/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FileTypeEnum } from './FileTypeEnum';
import {
    FileTypeEnumFromJSON,
    FileTypeEnumFromJSONTyped,
    FileTypeEnumToJSON,
    FileTypeEnumToJSONTyped,
} from './FileTypeEnum';

/**
 * Serializer for the EpaFormFile model.
 * @export
 * @interface EpaFormFile
 */
export interface EpaFormFile {
    /**
     * 
     * @type {string}
     * @memberof EpaFormFile
     */
    readonly id: string;
    /**
     * 
     * @type {boolean}
     * @memberof EpaFormFile
     */
    readonly uploadComplete: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EpaFormFile
     */
    readonly virusDetected: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EpaFormFile
     */
    readonly scanComplete: boolean;
    /**
     * 
     * @type {string}
     * @memberof EpaFormFile
     */
    file: string;
    /**
     * 
     * @type {FileTypeEnum}
     * @memberof EpaFormFile
     */
    fileType: FileTypeEnum;
    /**
     * Returns filename to API.
     * @type {string}
     * @memberof EpaFormFile
     */
    readonly filename: string;
}



/**
 * Check if a given object implements the EpaFormFile interface.
 */
export function instanceOfEpaFormFile(value: object): value is EpaFormFile {
    if (!('id' in value) || value['id'] === undefined) return false;
    if ((!('uploadComplete' in (value as Record<string, any>)) && !('upload_complete' in (value as Record<string, any>))) || ((value as Record<string, any>)['uploadComplete'] === undefined && (value as Record<string, any>)['upload_complete'] === undefined)) return false;
    if ((!('virusDetected' in (value as Record<string, any>)) && !('virus_detected' in (value as Record<string, any>))) || ((value as Record<string, any>)['virusDetected'] === undefined && (value as Record<string, any>)['virus_detected'] === undefined)) return false;
    if ((!('scanComplete' in (value as Record<string, any>)) && !('scan_complete' in (value as Record<string, any>))) || ((value as Record<string, any>)['scanComplete'] === undefined && (value as Record<string, any>)['scan_complete'] === undefined)) return false;
    if (!('file' in value) || value['file'] === undefined) return false;
    if ((!('fileType' in (value as Record<string, any>)) && !('file_type' in (value as Record<string, any>))) || ((value as Record<string, any>)['fileType'] === undefined && (value as Record<string, any>)['file_type'] === undefined)) return false;
    if (!('filename' in value) || value['filename'] === undefined) return false;
    return true;
}

export function EpaFormFileFromJSON(json: any): EpaFormFile {
    return EpaFormFileFromJSONTyped(json, false);
}

export function EpaFormFileFromJSONTyped(json: any, ignoreDiscriminator: boolean): EpaFormFile {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'uploadComplete': json['upload_complete'],
        'virusDetected': json['virus_detected'],
        'scanComplete': json['scan_complete'],
        'file': json['file'],
        'fileType': FileTypeEnumFromJSON(json['file_type']),
        'filename': json['filename'],
    };
}

export function EpaFormFileToJSON(json: any): EpaFormFile {
    return EpaFormFileToJSONTyped(json, false);
}

export function EpaFormFileToJSONTyped(value?: Omit<EpaFormFile, 'id'|'uploadComplete'|'virusDetected'|'scanComplete'|'filename'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'file': value['file'],
        'file_type': FileTypeEnumToJSON(value['fileType']),
    };
}

